/**
 * @flow
 * @relayHash 7d3d1c76c8e64d7c3bc61d25a9d94391
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FavoriteSellerInput = {|
  sellerPk: string,
  userId: string,
  favoriteId?: ?string,
  clientMutationId?: ?string,
|};
export type storefrontFollowDealerMutationVariables = {|
  input: FavoriteSellerInput,
  userId: string,
|};
export type storefrontFollowDealerMutationResponse = {|
  +favoriteSeller: ?{|
    +seller: ?{|
      +favoritesByUser: ?$ReadOnlyArray<?{|
        +serviceId: ?string
      |}>
    |}
  |}
|};
export type storefrontFollowDealerMutation = {|
  variables: storefrontFollowDealerMutationVariables,
  response: storefrontFollowDealerMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "FavoriteSellerInput!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "FavoriteSellerInput!"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "userIds",
    "variableName": "userId",
    "type": "String!"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "storefrontFollowDealerMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoriteSeller",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoritesByUser",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "Favorite",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "storefrontFollowDealerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "favoriteSeller",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "favoritesByUser",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "Favorite",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "storefrontFollowDealerMutation",
    "id": "app-buyer-misc/213.0.0-2019-04-24T16:13:25.915Z/storefrontFollowDealerMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '912a25bb1043faea3e9f3a5e5b7f9791';
module.exports = node;
